import { AxiosResponse } from 'axios'
import { axiosClient } from '@App/api/api-client'
import Pathes from '@App/dicts/pathes'

export const getNotificationToken = (): Promise<AxiosResponse<any>> => axiosClient.get(Pathes.Notification.token())
